"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeSwap = void 0;
const token_utils_1 = require("@saberhq/token-utils");
const web3_js_1 = require("@solana/web3.js");
const fees_1 = require("./fees");
const layout_1 = require("./layout");
__exportStar(require("./fees"), exports);
__exportStar(require("./layout"), exports);
/**
 * Decodes the Swap account.
 * @param data
 * @returns
 */
const decodeSwap = (data) => {
    const stableSwapData = layout_1.StableSwapLayout.decode(data);
    if (!stableSwapData.isInitialized) {
        throw new Error(`Invalid token swap state`);
    }
    const adminAccount = new web3_js_1.PublicKey(stableSwapData.adminAccount);
    const adminFeeAccountA = new web3_js_1.PublicKey(stableSwapData.adminFeeAccountA);
    const adminFeeAccountB = new web3_js_1.PublicKey(stableSwapData.adminFeeAccountB);
    const tokenAccountA = new web3_js_1.PublicKey(stableSwapData.tokenAccountA);
    const tokenAccountB = new web3_js_1.PublicKey(stableSwapData.tokenAccountB);
    const poolTokenMint = new web3_js_1.PublicKey(stableSwapData.tokenPool);
    const mintA = new web3_js_1.PublicKey(stableSwapData.mintA);
    const mintB = new web3_js_1.PublicKey(stableSwapData.mintB);
    const initialAmpFactor = token_utils_1.u64.fromBuffer(stableSwapData.initialAmpFactor);
    const targetAmpFactor = token_utils_1.u64.fromBuffer(stableSwapData.targetAmpFactor);
    const startRampTimestamp = stableSwapData.startRampTs;
    const stopRampTimestamp = stableSwapData.stopRampTs;
    const fees = (0, fees_1.decodeFees)(stableSwapData.fees);
    return {
        adminAccount,
        tokenA: {
            adminFeeAccount: adminFeeAccountA,
            reserve: tokenAccountA,
            mint: mintA,
        },
        tokenB: {
            adminFeeAccount: adminFeeAccountB,
            reserve: tokenAccountB,
            mint: mintB,
        },
        poolTokenMint,
        initialAmpFactor,
        targetAmpFactor,
        startRampTimestamp,
        stopRampTimestamp,
        fees,
    };
};
exports.decodeSwap = decodeSwap;
//# sourceMappingURL=index.js.map